<template>
  <div class="page-box">
    <el-pagination @current-change="handleCurrentChange" :current-page.sync="pageIndex" :page-size="size" layout="prev, pager, next" :page-count="count" background prev-text="<" next-text=">" :pager-count="pagerCount?pagerCount:7">
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: "Pagination",
  props: ["index", "size", "count", "screenWidth", "pagerCount"],
  data () {
    return {
      pageIndex: this.index,
    };
  },
  mounted () { },
  created () { },
  methods: {
    handleCurrentChange (e) {
      this.$emit("pageTurning", e);
    },
  },
  destroyed () { },
  watch: {
    index: function () {
      this.pageIndex = this.index;
    }
  }
};
</script>

<style scoped>
.page-box {
  /* padding: 3rem 2.5rem 3rem 2.5rem; */
  text-align: left;
  margin-top: 1rem;
  /* background: #fff; */
}
.el-pagination.is-background {
  width: 100% !important;
}
.el-pagination {
  padding: 0 !important;
}

/* 总共多少页 */
slot {
  display: inline-block !important;
  font-size: 1.3rem !important;
  color: #666 !important;
  font-weight: 500 !important;
  padding: 0.5rem 0.75rem !important;
}
/* 页码 */
.el-pagination.is-background .el-pager li {
  margin: 0 5px !important;
  background-color: transparent !important;
  color: #886ab5 !important;
  min-width: 30px !important;
  border-radius: 2px !important;
}
/* 页码 */
.el-pager li {
  padding: 0.5rem 0.75rem !important;
  height: inherit !important;
  line-height: inherit !important;
}
.el-pager .more::before {
  height: inherit !important;
  line-height: inherit !important;
}
/* 上一页，下一页 */
.el-pagination span {
  height: inherit !important;
  line-height: inherit !important;
  padding: 0.5rem 0.75rem !important;
}
.el-pagination button {
  height: inherit !important;
  line-height: inherit !important;
  /* padding: 0.5rem 0.75rem!important; */
}
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .btn-next {
  height: inherit !important;
  line-height: inherit !important;
}
/* 选中样式 */
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #886ab5 !important;
  color: #ffffff !important;
}

.el-pagination__jump {
  padding: inherit !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Pagination.vue